module.exports = __webpack_public_path__ + "img/prioritas_dfod_dg_k.a40a50f5.png";